module.exports = __webpack_public_path__ + "static/media/omnifood-gif.a0c37985.gif";